import { ApiProperty } from "@nestjs/swagger";

export class DepartmentIdReq {
    @ApiProperty()
    departmentId: number;
}